import axios from "axios";
import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/schedule_mng`;

export const GetScheduleMNG = async (token, date, restaurantId) => {
  try {
    const bodyRequest = {
      date: date,
      restaurant_id: restaurantId,
    };

    const response = await axios.post(`${API_URL}/table/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const GetScheduleMNGOnlyDirectus = async (token, date) => {
  try {
    const response = await axios.get(
      `${API_URL}/table_only_directus/?date=${date}`,
      // { date: date },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};
